<template></template>

<script>
import { getAuthCode, getSessionId } from "../../api/HttpService";
export default {
  data: function () {
    return {
      channelCode: null,
      chlAppId: null,
    };
  },
  methods: {},
  mounted: async function () {
    this.channelCode = this.$route.query.channelCode;
    window.localStorage.setItem("channelCode_AI", this.channelCode);
    // 如果是微信小程序
    if (window.__wxjs_environment) {
      window.localStorage.setItem("clientType_AI", "wechat");
      window.localStorage.setItem("channel_App", "wechat");
    } else {
      window.localStorage.setItem("clientType_AI", "app");
      window.localStorage.setItem("channel_App", "app");
    }

    // 计算apiPath
    switch (this.channelCode) {
      case "dxlc":
        this.apiPath = "./liuzhouGateway";
        break;
      case "cxnt":
        this.apiPath = "./nantongGateway";
        break;
      case "pinba":
        this.apiPath = "./pinbaGateway";
        break;
      case "linkfashion":
        this.apiPath = "./fuzhuangGateway";
        break;
    }
    console.log(this.$route.query);
    if (this.$route.query.sessionId) {
      window.localStorage.setItem("sessionId", this.$route.query.sessionId);
      window.localStorage.removeItem("sessionId_AI");
      getAuthCode(
        {
          newFlag: true,
        },
        this.apiPath,
        this.channelCode == "pinba" ? "cstmbus.user.h5" : null
      )
        .then(({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            // 拿到authCode
            // 再去换sessionId
            getSessionId({
              authCode: res.data,
              system: this.channelCode,
            })
              .then(({ res }) => {
                console.log(res);
                if (res.code == "SUCCESS") {
                  // 拿到了最终的sessionId
                  window.localStorage.setItem(
                    "sessionId_AI",
                    res.originalData.data.sessionId
                  );
                  window.localStorage.setItem(
                    "appId_AI",
                    res.originalData.data.appId
                  );
                  window.localStorage.setItem(
                    "userId_AI",
                    res.originalData.data.userId
                  );
                  const thisUserId = res.originalData.data.userId;
                  window._czc && window._czc.push(["_setUUid", thisUserId]);
                  // 如果此时地址栏中存在ai_app_code
                  // 那么跳到列表后，要直接加载该智能体
                  if (this.$route.query.ai_app_code) {
                    console.log(
                      "地址栏中存在ai_app_code",
                      this.$route.query.ai_app_code
                    );
                    this.$router.replace({
                      name: "ChatListPage",
                      params: {
                        autoJumpToAgent: this.$route.query.ai_app_code,
                        userInputs: this.userInputs || null,
                      },
                    });
                  }
                  // 跳到发现页
                  else if (this.$route.query.jumpFind) {
                    this.$router.replace({
                      name: "ChatListPage",
                      params: {
                        jumpFind: true,
                      },
                    });
                  } else {
                    this.$router.replace({
                      name: "ChatListPage",
                    });
                  }
                }
              })
              .catch((err) => {});
          }
        })
        .catch((err) => {});
    }
  },
};
</script>

<style></style>
